module.exports = "<p>\n  products-lists-item-food works!\n</p>\n"